window.MITO = window.MITO || {};

$(document).ready(function () {
  var DEFAULT_AMOUNT = '$0.00';

  function formatMoney(number) {
    var float = parseFloat(number, 10);
    if (isNaN(float)) {
      return false;
    }
    return '$' + float.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }

  $('#Form_PaymentForm_Amount').on('keyup', function () {
    var amount = formatMoney($(this).val());
    if (amount) {
      $('#Form_PaymentForm_TotalAmount').html(amount);
    } else {
      $('#Form_PaymentForm_TotalAmount').html(DEFAULT_AMOUNT);
    }
  });

  /* Enrolment Page */

  if ($('.js-course-options').length) {
    var ENROLMENT_DEFAULT_AMOUNT = '$402.50',
      $mtaNumber = $('.js-mta-number.form-group'),
      $options = $('.js-course-options.form-group'),
      $total = $('#Form_PaymentForm_TotalAmount'),
      defaultVal = $options.find('input[type=radio]:checked'),
      val = defaultVal.length ? formatMoney(defaultVal.val()) : ENROLMENT_DEFAULT_AMOUNT;

    $total.html(val);

    $options.on('change', 'input[type=radio]', function () {
      var amount = formatMoney($(this).val());
      if (amount) {
        $('#Form_PaymentForm_TotalAmount').html(amount);
        if (amount === ENROLMENT_DEFAULT_AMOUNT) {
          $mtaNumber.hide();
        } else {
          $mtaNumber.show();
        }
      } else {
        $('#Form_PaymentForm_TotalAmount').html(ENROLMENT_DEFAULT_AMOUNT);
      }
    });
  }

  if ($('.js-form-options').length) {
    var $formOptions = $('.js-form-options.form-group'),
      $target = $('.js-disability.form-group');
    $formOptions.on('change', 'input[type=radio]', function () {
      var val = $(this).val();
      if (val == 1) {
        $target.show();
      } else {
        $target.hide();
      }
    });
  }
});
